import { formatHumanName } from '@medplum/core';
import type { HumanName } from '@medplum/fhirtypes';

/** Account-menu display name from a FHIR profile HumanName (text or given+family). */
export function profileAccountDisplayName(
  profile: { name?: HumanName[] } | undefined,
  fallback = 'User',
): string {
  const n = profile?.name?.[0];
  if (!n) return fallback;
  return n.text?.trim() || formatHumanName(n).trim() || fallback;
}
